module.exports = __webpack_public_path__ + "static/img/logo.2838a84.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.gif
// module id = CyRJ
// module chunks = 1